import { RawRule } from '@casl/ability';
import { CAN_ADD, CAN_DELETE, CAN_SIGN, CAN_UPDATE, CAN_VIEW } from 'shared/constants/actions';
import { IRolePermission } from 'store/state/auth-state';
import { ApplicationModule } from 'shared/enums/application-module';

export function ConvertAbility(permissions: IRolePermission[]): RawRule[] {
    const abilities = new Array<RawRule>();
    permissions.forEach((permission: IRolePermission) => {
        if (permission.CanView || permission.CanManage || permission.CanDelete) {
            const actions: string[] = [CAN_VIEW];
            if (permission.CanManage) {
                actions.push(CAN_ADD);
                actions.push(CAN_UPDATE);
            }
            if (permission.CanDelete) actions.push(CAN_DELETE);
            if (permission.CanSign) actions.push(CAN_SIGN);
            abilities.push({
                subject: permission.ModuleName,
                actions: actions,
            });
        }
    });

    abilities.push({ subject: ApplicationModule.InitialPlan, actions: [CAN_VIEW] });
    abilities.push({ subject: ApplicationModule.Dashboard, actions: [CAN_VIEW] });
    return abilities;
}
